createAbsolute